import React, { useState } from "react";
import TitleSection from "../components/TitleSection/TitleSection";
import ContactFormPages from "../components/ContactFormPages";
import { Images } from "../assets";
import { useTranslation } from "react-i18next";

const Realisations = () => {
  const { t } = useTranslation();

  const allProjects = [
    {
      title: t("projects.project1.title"),
      subtitle: t("projects.project1.subtitle"),
      images: [
        Images.PROJECT1_PICTURE1,
        Images.PROJECT1_PICTURE2,
        Images.PROJECT1_PICTURE3,
      ],
      description: [
        t("projects.project1.description1"),
        t("projects.project1.description2"),
      ],
      invert: false,
    },
    {
      title: t("projects.project2.title"),
      subtitle: t("projects.project2.subtitle"),
      images: [
        Images.PROJECT2_PICTURE1,
        Images.PROJECT2_PICTURE2,
        Images.PROJECT2_PICTURE3,
      ],
      description: [
        t("projects.project2.description1"),
        t("projects.project2.description2"),
      ],
      invert: true,
    },
    {
      title: t("projects.project3.title"),
      subtitle: t("projects.project3.subtitle"),
      images: [
        Images.PROJECT3_PICTURE1,
        Images.PROJECT3_PICTURE2,
        Images.PROJECT3_PICTURE3,
      ],
      description: [
        t("projects.project3.description1"),
        t("projects.project3.description2"),
      ],
      invert: false,
    },
    {
      title: t("projects.project4.title"),
      subtitle: t("projects.project4.subtitle"),
      images: [
        Images.PROJECT4_PICTURE1,
        Images.PROJECT4_PICTURE2,
        Images.PROJECT4_PICTURE3,
      ],
      description: [
        t("projects.project4.description1"),
        t("projects.project4.description2"),
      ],
      invert: true,
    },
  ];

  const [visibleProjects, setVisibleProjects] = useState(2);

  const handleLoadMore = () => {
    setVisibleProjects((prev) => prev + 2);
  };

  const handleLoadLess = () => {
    setVisibleProjects(2);
  };

  const ImageGrid = ({ images }) => {
    return (
      <div className="grid grid-cols-2 grid-rows-2 gap-5 w-full h-full max-h-[40vh] md:max-h-auto">
        {/* Top image */}
        <div className="col-span-2 overflow-hidden rounded-xl">
          <img
            src={images[0]}
            alt="Grille 1"
            className="w-full h-full object-cover block"
          />
        </div>

        {/* Bottom two */}
        <div className="overflow-hidden rounded-xl">
          <img
            src={images[1]}
            alt="Grille 2"
            className="w-full h-full object-cover block"
          />
        </div>
        <div className="overflow-hidden rounded-xl">
          <img
            src={images[2]}
            alt="Grille 3"
            className="w-full h-full object-cover block"
          />
        </div>
      </div>
    );
  };

  const Project = ({
    title = "Nom du projet",
    subtitle = "Sous-titre du projet",
    images = [],
    description = [],
    invert = false,
  }) => {
    return (
      <div
        className={`flex flex-col md:flex-row items-stretch justify-between gap-5 ${
          invert ? "md:flex-row-reverse" : "md:flex-row"
        } h-auto md:h-[30vh]`}
      >
        <div className="w-full md:w-2/5 h-full">
          <ImageGrid images={images} />
        </div>
        <div
          className={`flex flex-col items-start justify-center rounded-xl px-5 py-5 w-full md:w-3/5 h-full ${
            invert ? "bg-orange" : "bg-transparent border border-orange"
          }`}
        >
          <h3 className="font-title text-2xl text-start tracking-wider mb-2 md:mb-0">
            {title}
          </h3>
          <h4 className="font-title text-start mb-5">{subtitle}</h4>
          <div className="space-y-2 text-start md:text-justify">
            {description.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <TitleSection
        title={t("projects.title")}
        subtitle={t("projects.subtitle")}
        highlightWords={[
          t("projects.highlightWords1"),
          t("projects.highlightWords2"),
          t("projects.highlightWords3"),
          t("projects.highlightWords4"),
        ]}
        bgImg={Images.RD_BG_IMAGE}
      />

      <div className="flex flex-col mx-5 md:mx-10 my-10">
        {/* Projects */}
        <section className="mt-12">
          <h2 className="font-title text-3xl md:text-4xl text-start mb-10">
            {t("projects.projectsTitle")}{" "}
            <span className="text-orange">
              {t("projects.projectsHighlight")}
            </span>
          </h2>
          <div className="flex flex-col gap-28 md:gap-20">
            {allProjects.slice(0, visibleProjects).map((project, index) => (
              <Project key={index} {...project} />
            ))}
          </div>
        </section>

        {/* Load more button */}
        {visibleProjects < allProjects.length ? (
          <button
            className="flex items-center gap-3 mx-auto text-2xl mt-14 mb-16 py-3 text-white"
            onClick={handleLoadMore}
          >
            {t("projects.loadMore")}{" "}
            <img src={Images.VIEW_MORE} alt="Voir plus" />
          </button>
        ) : (
          <button
            className="flex items-center gap-3 mx-auto text-2xl mt-14 mb-16 py-3 text-white"
            onClick={handleLoadLess}
          >
            {t("projects.loadLess")}{" "}
            <img
              src={Images.VIEW_MORE}
              alt="Voir plus"
              className="transform rotate-180"
            />
          </button>
        )}
      </div>

      <ContactFormPages />
    </>
  );
};

export default Realisations;
